import { IDialogAction } from './IDialogAction';
import { DialogSignalRService } from '../services/DialogSignalRService';
import { Store } from 'redux';
import { DialogState } from '../models/DialogState';
import { DialogAudience } from '../models/feed/DialogAudience';

export const ADD_AUDIENCE_FILTER = 'ADD_AUDIENCE_FILTER';

export class AddAudienceFilterAction implements IDialogAction {
    public readonly type = ADD_AUDIENCE_FILTER;
    public constructor(public payload: any, private _service?: DialogSignalRService) {}
    public middleware(store: Store): any {
        if(this._service) {
            let state = store.getState() as DialogState;
            let newAudienceFilters: DialogAudience[] = this.payload.audiences;
            //newAudienceFilters.push(...state.feed.audienceFilters);
            this._service.setFilter(
                state.feed.currentTabId,
                newAudienceFilters
            );
        }
        return;
    }
    public reducer(state: DialogState): any {
        let newAudienceFilters: DialogAudience[] = this.payload.audiences;
        state.feed.audienceFilters = newAudienceFilters;//.push(...newAudienceFilters);
        state.feed.messagesReady = false;
        state.feed.messages = [];
        state.feed.tabs.forEach(t => {
            t.addedMessages = [];
            t.notification = 0;
        });
        return state;
    }
}

export const AddAudienceFilterActionTypeMapping = {
    [ADD_AUDIENCE_FILTER]: AddAudienceFilterAction
};